<template>
  <f7-page>
    <div v-if="loaded">
      <div class="custom-table-container tableContainer">
        <div class="summary-header">
          <div class="summary-title">
            <div class="summary-icon-alerts"></div>
            <div class="summary-text">
              {{ $t('alerts') }} > {{ $t('alert.parameters') }}
            </div>
          </div>
        </div>
        <!-- Submenú en la parte superior del card -->
        <div>
          <SubMenu
            :items="MenuOptions.contexts.alerts.subMenu.params"
          />
        </div>
        <AlertsTable :store="customStore" :params="params" />
      </div>
    </div>
  </f7-page>
</template>
<script>
import { mapActions } from 'vuex';
import AlertsTable from '@/components/Alerts/Settings/ParamsTable/index.vue';
import EventBus from '@/services/event-bus';
import Helpers from '@/js/helpers';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import MenuOptions from '@/json/menuOptions.json';
import SubMenu from '@/components/SubMenu/index.vue';

export default {
  name: 'AlertsParamsPage',
  components: {
    AlertsTable,
    SubMenu,
  },
  data() {
    return {
      loaded: false,
      customStore: null,
      params: {},
      MenuOptions,
    };
  },
  async beforeMount() {
    this.loaded = false;
    this.setCurrentRoute([
      {
        name: this.$t('alerts'),
        disabled: false,
        page: 'AlertsParamsPage',
        active: false,
      },
      {
        name: this.$t('alert.parameters'),
        disabled: false,
        page: 'AlertsParamsPage',
        active: false,
      },
      {
        name: this.$t('settings'),
        disabled: true,
        page: 'AlertsParamsPage',
        active: true,
      },
    ]);
    this.setCurrentFilter('alertSettingsParams');

    try {
      this.customStore = await this.getStore();

      EventBus.$on('AlertsParamsPage', async (params) => {
        if (params) {
          this.params = params;
          this.customStore = await this.getStoreWithFilters(params);
        } else {
          this.params = {};
          this.customStore = await this.getStore();
        }
      });

      EventBus.$on('newParamAlert', async (params) => {
        if (Helpers.isEmptyObject(params)) {
          this.customStore = await this.getStore();
        } else {
          this.customStore = await this.getStoreWithFilters(params);
        }
      });

      this.loaded = true;
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    }
  },
  methods: {
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('alertsParams', [
      'getStore',
      'getStoreWithFilters',
    ]),
    ...mapActions('filter', ['setCurrentFilter']),
  },
};
</script>
<style>
.summary-header {
  margin: 12px;
  margin-bottom: 0px;
}
.summary-icon-alerts {
  width: 28px;
  height: 28px;
  background-image: url('@/static/icons/ic_alerts.svg');
}
</style>
